















































import { Vue, Component } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';

@Component
export default class Login extends Vue {
  private formData = {
    schoolId: '',
    userId: '',
    password: ''
  };

  private formRule = {
    schoolId: [
      { required: true, message: 'スクールIDを入力してください' },
    ],
    userId: [
      { required: true, message: '講師IDを入力してください' },
    ],
    password: [
      { required: true, message: 'パスワードを入力してください' },
    ],
  };

  private created() {
    this.$store.dispatch('auth/logout');
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    const schoolId = this.$route.query.schoolId as string;
    const userId = this.$route.query.userId as string;

    if (!!schoolId) {
      this.formData.schoolId = schoolId;
    } else {
      this.formData.schoolId = this.$store.state.auth.latestSchoolId;
    }
    if (!!userId) {
      this.formData.userId = userId;
    }

    if (this.formData.schoolId === '') {
      (this.$refs.schoolId as any).focus();
    } else if (this.formData.userId === '') {
      (this.$refs.userId as any).focus();
    } else {
      (this.$refs.password as any).focus();
    }
  }

  private async login() {
    (this.$refs.form as ElForm).validate(async (valid) => {
      if (!valid) {
        return false;
      } else {
        try {
          await this.$store.dispatch('auth/login', {
            schoolId: this.formData.schoolId,
            userId: this.formData.userId,
            password: this.formData.password
          });
        } catch (error) {
          this.formData.password = '';
          this.$notify.error({
            title: 'ログインエラー',
            message: error.message,
            position: 'bottom-right'
          });
          return;
        }
        this.$router.push({ name: 'Top' });
      }
    });
  }
}
